import { defineEvent } from '../types/event';
export var NOTIFY_ME_SUBSCRIBE = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Set_Notify_Me'
        }
    ]
});
